(ns com.theplantscape.calculate.core
  (:require [clojure.math :refer [atan2 sqrt cos sin]]))

(defn closest-value [target numbers]
  (reduce (fn [closest radius]
            (if (<  (Math/abs (- target radius))
                    (Math/abs (- target closest)))
              radius
              closest))
          (first numbers)
          (rest numbers)))

;; (is (= 1 (closest-value 4.27 [1 40 60])))
;; (closest-value 10 [1 40 60])
;; (closest-value 30 [1 40 60])
;; (closest-value 40 [1 40 60])
;; (closest-value 45 [1 40 60])

(defn direction-vector
  "Calculate direction vector also known as angle of the line"
  [[x1 y1] [x2 y2]]
  (let [xDiff (- x2 x1)
        yDiff (- y2 y1)]
    ;; js/Math.atan2
    (atan2 yDiff xDiff)))

(defn extend-line [[x1 y1] [x2 y2] extension-length]
  (let [angle (direction-vector [x1 y1] [x2 y2])
        new-end-x (+ x2 (* extension-length (cos angle)))
        new-end-y (+ y2 (* extension-length (sin angle)))]
    [[x1 y1] [new-end-x new-end-y]]))

(defn line-circle-intersection [[x1 y1] [x2 y2] [cx cy] r]
  (let [dx (- x2 x1)
        dy (- y2 y1)
        a (+ (* dx dx) (* dy dy))
        b (* 2 (* dx (- x1 cx)) (* dy (- y1 cy)))
        c (- (+ (* cx cx) (* cy cy) (* x1 x1) (* y1 y1) (* -2 (* cx x1)) (* -2 (* cy y1)) (* r r)))
        disc (- (* b b) (* 4 (* a c)))
        t1 (/ (+ (- b) (sqrt disc)) (* 2 a))
        t2 (/ (- (- b) (sqrt disc)) (* 2 a))
        i1 (if (and (>= t1 0) (< t1 1)) (list (+ x1 (* t1 dx)) (+ y1 (* t1 dy))) nil)
        i2 (if (and (>= t2 0) (< t2 1)) (list (+ x1 (* t2 dx)) (+ y1 (* t2 dy))) nil)]
    (if (and i1 i2)
      [i1 i2]
      (if i1 [i1] i2))))

(defn radius
  "Calculate radius from two points"
  [[center-x center-y] [point-x point-y]]
  (int (let [dx (- point-x center-x)
             dy (- point-y center-y)]
         (Math/sqrt (+ (* dx dx) (* dy dy))))))

(defn generate-radius [distance number]
  (reduce #(conj %1 (* %2 distance)) [1] (range 1 number)))


(defn snap-closest-radius [center point radius-sequence]
  (let [radius-seq radius-sequence
        user-radius (radius center point)]
    (closest-value user-radius radius-sequence)))

(defn average-points [points]
  [(/ (reduce + (map first points)) (count points))
   (/ (reduce + (map second points)) (count points))])

(defn -vec [xy1 xy2]
  (map - xy1 xy2))

(defn +vec [xy1 xy2]
  (map + xy1 xy2))

(defn snap-grid [[x y] size snap]
  #?(:clj (if snap
            ;; not implemented yet
            [x y])
     :cljs (if snap
             [(* (.round js/Math (/ x size)) size)
              (* (.round js/Math (/ y size)) size)]
             [x y])))

(defn seq-min-max [m [x y]]
  (-> m
      (assoc :x
             {:min (if (< x (or (-> m :x :min) x)) x (or (-> m :x :min) x))
              :max (if (> x (or (-> m :x :max) x)) x (or (-> m :x :max) x))})
      (assoc :y
             {:min (if (< y (or (-> m :y :min) y)) y (or (-> m :y :min) y))
              :max (if (> y (or (-> m :y :max) y)) y (or (-> m :y :max) y))})))
